<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0">Charlie Palmer is a 50-year-old voluntary worker who fills his days apologising for a big-boned Labrador. He has previously had a short story published, but <em>Sitting Down with Evil</em> is his first novel.</p><br/>
<p style="text-indent:0">He lives in Colchester with his wife Emma. His two sons, Louis and Oli, have flown the coop for university studies. In his spare time, Charlie follows Formula 1 and travels to satisfy his Epicurean urges. Needless to say, 2020 remains a constant source of disappointment to him.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6a003dcc